// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* src/index.css */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;", ""]);
// Exports
module.exports = exports;
